import { useEffect, useState } from "react";
import { clearAllCart } from "@/src/lib/store/add-to-cart/slice";
import { useDispatch } from "react-redux";
import { useToast } from "@/src/lib/hooks/useToast";
import CustomButton from "@/src/lib/ui/Button";

const RemoveCart = ({
    existingCartCentre,
    currentCentre,
    replaceCartHandler,
    onCloseHandler,
}) => {
    const { showCustomToast } = useToast();
    const dispatch = useDispatch();
    const [currentSelectedCentre, setCurrentSelectedCentre] =
        useState(currentCentre);

    useEffect(() => {
        setCurrentSelectedCentre(currentCentre);
    }, [currentCentre]);

    const clearAllCartHandler = () => {
        dispatch(clearAllCart());
        showCustomToast("Cart Cleared Successfully", "success");

        //clearAllCart();
        onCloseHandler();
    };

    return (
        <div>
            <h2 className="font-bold text-black text-lg">
                Tests for {existingCartCentre} are already in cart!
            </h2>
            <p className="font-normal text-black text-base">
                Please confirm if you would like to continue booking at{" "}
                {existingCartCentre} or change to{" "}
                {currentSelectedCentre?.centre}?
            </p>

            <div className="flex flex-row gap-1 mt-5">
                <CustomButton
                    onClick={onCloseHandler}
                    className="capitalize max-w-20"
                    fullWidth
                    variant="outlined"
                >
                    Cancel
                </CustomButton>
                <CustomButton
                    onClick={clearAllCartHandler}
                    className="capitalize max-w-32"
                    fullWidth
                    variant="outlined"
                >
                    Clear Cart
                    {/* {`continue for ${existingCartCentre}`} */}
                </CustomButton>
                <CustomButton
                    className="w-full capitalize max-w-96"
                    fullWidth
                    variant="contained"
                    onClick={() => replaceCartHandler(currentSelectedCentre)}
                >
                    {`switch to ${currentSelectedCentre?.centre}`}
                </CustomButton>
            </div>
        </div>
    );
};

export default RemoveCart;
